import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/historial_economicos/historial_economicos';
import Listar from './Listar';


const ms2p = (state) => {
  return {
    ...state.historial_economicos,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Listar);
